import { string, object, date, SchemaOf, DateSchema, boolean } from 'yup';

import dayjs from 'dayjs';

import { END_DATE_BEFORE_START_DATE, INVOICE_DATE_BEFORE_START_DATE, REQUIRED_FIELD_FOR_SO } from '@/config/text.const';


export type Fields = {
  billingEndDate?: Date | null;
  billingStartDate?: Date | null;
  invoiceDate?: Date | null;
  notes?: string | null;
  productName?: string | null;
  generationOrMatchWasTriggered?: boolean;

};

export const validationSchema: SchemaOf<Fields> = object().shape({
  invoiceDate: date()
    .when('generationOrMatchWasTriggered', {
      is: (generationOrMatchWasTriggered?: boolean) => generationOrMatchWasTriggered === true,
      then: (schema: DateSchema) => schema.required(REQUIRED_FIELD_FOR_SO)
    })
    .test((value, context) => {
      const billingStartDate = context?.parent?.billingStartDate;
      if (value && billingStartDate && dayjs(value).isBefore(billingStartDate, 'date')) {
        return context.createError({
          path: 'invoiceDate',
          message: INVOICE_DATE_BEFORE_START_DATE
        });
      }
      return true;
    })
    .nullable(),
  billingStartDate: date()
    .when('generationOrMatchWasTriggered', {
      is: (generationOrMatchWasTriggered?: boolean) => generationOrMatchWasTriggered === true,
      then: (schema: DateSchema) => schema.required(REQUIRED_FIELD_FOR_SO)
    })
    .nullable(),
  billingEndDate: date()
    .when('generationOrMatchWasTriggered', {
      is: (generationOrMatchWasTriggered?: boolean) => generationOrMatchWasTriggered === true,
      then: (schema: DateSchema) => schema.required(REQUIRED_FIELD_FOR_SO)
    })
    .test((value, context) => {
      const billingStartDate = context?.parent?.billingStartDate;
      if (value && billingStartDate && dayjs(value).isBefore(billingStartDate, 'date')) {
        return context.createError({
          path: 'billingEndDate',
          message: END_DATE_BEFORE_START_DATE
        });
      }
      return true;
    })
    .nullable(),
  productName: string().nullable(),
  notes: string()
    .max(1000, 'Must be maximum ${max} characters')
    .nullable(),
  generationOrMatchWasTriggered: boolean()
});
